import { FormGroup } from "@angular/forms";
var HarvestInstructionsComponent = /** @class */ (function () {
    function HarvestInstructionsComponent() {
    }
    Object.defineProperty(HarvestInstructionsComponent.prototype, "minimumSeedsToReturn", {
        get: function () {
            return this.harvestInstructions.get('minimumSeedsToReturn');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HarvestInstructionsComponent.prototype, "forAdvancement", {
        get: function () {
            return this.harvestInstructions.get('forAdvancement');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HarvestInstructionsComponent.prototype, "haploidInduction", {
        get: function () {
            return this.harvestInstructions.get('haploidInduction');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HarvestInstructionsComponent.prototype, "manyToOne", {
        get: function () {
            return this.harvestInstructions.get('manyToOne');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HarvestInstructionsComponent.prototype, "uniquePedigree", {
        get: function () {
            return this.harvestInstructions.get('uniquePedigree');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HarvestInstructionsComponent.prototype, "showHarvestFollowupOptions", {
        get: function () {
            return this.forAdvancement && this.forAdvancement.value === true;
        },
        enumerable: true,
        configurable: true
    });
    HarvestInstructionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.forAdvancement.valueChanges.subscribe(function (isForAdvancement) {
            if (isForAdvancement === false) {
                _this.haploidInduction.setValue(false);
                _this.manyToOne.setValue(false);
                _this.uniquePedigree.setValue(false);
            }
            _this.haploidInduction.updateValueAndValidity();
            _this.manyToOne.updateValueAndValidity();
            _this.uniquePedigree.updateValueAndValidity();
        });
    };
    return HarvestInstructionsComponent;
}());
export { HarvestInstructionsComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/harvest-instructions/harvest-instructions.component.ts.pre-build-optimizer.js